import ProjectUserSession from "../project-user-session";

// const debug = "ProjectAccessControl"
const debug = false

export class ProjectUserAccessControl {

    private projectUser : ProjectUserSession // ProjectUserFull |

    constructor(projectUser:ProjectUserSession) {
        this.projectUser = projectUser
    }

    get canDelete(): boolean {

        // this is a case when tag public - so we cant delete manually
        if (this.projectUser.project.accessModeIsPublic) return false

        return true
    }

}

